import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["inputs", "onChange", "onBlur"];
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { RadioGroup as RadioGroupPoi } from 'hoi-poi-ui';
function BooleanRadioGroup(_ref) {
  let {
      inputs,
      onChange,
      onBlur
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    setOptions(inputs.map(input => ({
      label: input.label,
      value: input.name
    })));
  }, [inputs]);
  const onChangeRadioGroup = useCallback(value => {
    const values = inputs.reduce((obj, input) => {
      obj[input.name] = value === input.name;
      return obj;
    }, {});
    onBlur && onBlur(values);
  }, [inputs, onBlur]);
  const value = useMemo(() => {
    const selectedInput = inputs.find(input => props.value[input.name]);
    return selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.name;
  }, [inputs, props.value]);
  return /*#__PURE__*/React.createElement(RadioGroupPoi, _extends({}, props, {
    options: options,
    onChange: onChangeRadioGroup,
    value: value,
    isFullWidth: false
  }));
}
export default BooleanRadioGroup;